export const WESTERN_SIGN_DATE_KEYS = [
  "aries",
  "taurus",
  "gemini",
  "cancer",
  "leo",
  "virgo",
  "libra",
  "scorpio",
  "sagittarius",
  "capricorn",
  "aquarius",
  "pisces",
];

export const WESTERN_SIGN_RULER_KEYS = [
  "mars",
  "venus",
  "mercury",
  "moon",
  "sun",
  "mercury",
  "venus",
  "pluto",
  "jupiter",
  "saturn",
  "uranus",
  "neptune",
];

export const WESTERN_SIGN_STRENGTH_KEYS = WESTERN_SIGN_DATE_KEYS;
export const WESTERN_SIGN_GROWTH_KEYS = WESTERN_SIGN_DATE_KEYS;

/** Sign key → planet key (matches Dashboard::PlanetaryPositionsBuilder#sign_ruler). */
export const WESTERN_SIGN_RULER_BY_KEY = Object.fromEntries(
  WESTERN_SIGN_DATE_KEYS.map((signKey, index) => [signKey, WESTERN_SIGN_RULER_KEYS[index]])
);

export const WESTERN_ELEMENT_COMPAT = {
  Fire: ["Aries", "Leo", "Sagittarius", "Gemini", "Libra", "Aquarius"],
  Earth: ["Taurus", "Virgo", "Capricorn", "Cancer", "Scorpio", "Pisces"],
  Air: ["Gemini", "Libra", "Aquarius", "Aries", "Leo", "Sagittarius"],
  Water: ["Cancer", "Scorpio", "Pisces", "Taurus", "Virgo", "Capricorn"],
};

export function buildWesternSignDateRanges(t) {
  return WESTERN_SIGN_DATE_KEYS.map((key) => t(`wz_sign_dates_${key}`));
}

export function buildWesternSignRulers(t) {
  return WESTERN_SIGN_RULER_KEYS.map((key) => t(`wz_planet_${key}`));
}

export function buildWesternSignStrengths(t) {
  return WESTERN_SIGN_STRENGTH_KEYS.map((key) => t(`wz_sign_strength_${key}`));
}

export function buildWesternSignGrowthEdges(t) {
  return WESTERN_SIGN_GROWTH_KEYS.map((key) => t(`wz_sign_growth_${key}`));
}

/** Static sign copy for All Signs modal before a chart is generated (API fills sign_profiles after). */
export function resolveWesternSignProfile(signName, signProfilesByKey, t) {
  const key = String(signName || "").toLowerCase();
  const fromApi = signProfilesByKey?.[key] || {};
  const rulerPlanetKey = WESTERN_SIGN_RULER_BY_KEY[key];
  const fallbackRuler = rulerPlanetKey ? t(`wz_planet_${rulerPlanetKey}`) : "";

  return {
    dateRange: fromApi.dateRange || t(`wz_sign_dates_${key}`),
    ruler: fromApi.ruler || fallbackRuler,
    strength: fromApi.strength || t(`wz_sign_strength_${key}`),
    growthEdge: fromApi.growthEdge || t(`wz_sign_growth_${key}`),
  };
}

export function buildWesternPlanetInterpretations(t) {
  return {
    Sun: t("wz_interp_sun"),
    Moon: t("wz_interp_moon"),
    Mercury: t("wz_interp_mercury"),
    Venus: t("wz_interp_venus"),
    Mars: t("wz_interp_mars"),
    Jupiter: t("wz_interp_jupiter"),
    Saturn: t("wz_interp_saturn"),
    Uranus: t("wz_interp_uranus"),
    Neptune: t("wz_interp_neptune"),
  };
}
